var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter"},[_c('Customdown',{attrs:{"deadline":"October 14, 2020","stunden":"12"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }